/* PINAKA theme behaviour: cart, gallery, chat, divine effects */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- reveal on scroll ---------- */
  function armReveals() {
    var els = $$('.reveal:not(.is-in)');
    if (!els.length || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- chakra scroll marker ---------- */
  function armChakra() {
    var ch = $('.chakra'); if (!ch) return;
    var spin = $('.chakra__spin', ch);
    function tick() {
      var y = window.scrollY || 0;
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      ch.style.background = 'conic-gradient(var(--gold) ' + (Math.min(1, y / max) * 360) + 'deg, rgba(236,229,216,.14) 0deg)';
      if (spin) spin.style.transform = 'rotate(' + (y * 0.35) + 'deg)';
    }
    window.addEventListener('scroll', tick, { passive: true }); tick();
  }

  /* ---------- hero video: intro then crossfade to loop ---------- */
  function armHero() {
    var media = $('.hero__media'); if (!media) return;
    var vids = $$('video', media), a = vids[0], b = vids[1];
    if (!a) return;
    a.muted = true; a.loop = !b; a.playsInline = true;
    var play = function (v) { if (!v) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    play(a);
    var tries = 0, t = setInterval(function () {
      if (a.readyState >= 2 || ++tries > 5) { clearInterval(t); return; }
      a.load(); play(a);
    }, 4000);
    if (b) {
      b.muted = true; b.loop = true; b.playsInline = true; b.load();
      a.addEventListener('ended', function () {
        b.currentTime = 0; play(b); b.style.opacity = '1';
        setTimeout(function () { a.style.opacity = '0'; a.pause(); }, 120);
      });
    }
    $$('.reel video').forEach(function (v) {
      v.muted = true;
      v.addEventListener('mouseenter', function () { play(v); });
      v.addEventListener('mouseleave', function () { v.pause(); });
    });
  }

  /* ---------- divine burst ---------- */
  function burst() {
    var el = $('#DivineBurst'); if (!el) return;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 1500);
  }

  /* ---------- cart ---------- */
  function openCart() { var d = $('#CartDrawer'); if (d) d.hidden = false; }
  function closeCart() { var d = $('#CartDrawer'); if (d) d.hidden = true; }

  function refreshCart() {
    return fetch(window.PINAKA.routes.cart + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cart-body]');
        var here = $('[data-cart-body]');
        if (next && here) here.innerHTML = next.innerHTML;
        return fetch(window.PINAKA.routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (n) { n.textContent = ('0' + cart.item_count).slice(-2); });
        return cart;
      })
      .catch(function () {});
  }

  function addToCart(id, qty) {
    return fetch(window.PINAKA.routes.cart_add, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      burst();
      return refreshCart();
    }).then(function () { setTimeout(openCart, 1150); });
  }

  function changeLine(line, qty) {
    return fetch(window.PINAKA.routes.cart_change, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { return refreshCart(); });
  }

  /* ---------- quick add modal ---------- */
  function openQuickAdd(handle) {
    var modal = $('#SizeModal'); if (!modal) return;
    var body = $('[data-quick-body]', modal);
    body.innerHTML = '<div class="opt-label">LOADING…</div>';
    modal.hidden = false;
    fetch('/products/' + handle + '?view=quick').then(function (r) { return r.text(); }).then(function (html) { body.innerHTML = html; });
  }

  /* ---------- product gallery ---------- */
  function armGallery(root) {
    var main = $('.gallery__main', root); if (!main) return;
    $$('.gallery__thumb', root).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.gallery__thumb', root).forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        var kind = t.getAttribute('data-kind'), src = t.getAttribute('data-src'), poster = t.getAttribute('data-poster') || '';
        main.innerHTML = kind === 'video'
          ? '<video src="' + src + '" poster="' + poster + '" controls muted loop playsinline preload="metadata"></video>'
          : '<img src="' + src + '" alt="">';
      });
    });
  }

  /* ---------- variant picking ---------- */
  function armVariants(form) {
    var data = JSON.parse($('[data-variants]', form).textContent || '[]');
    var idInput = $('[name="id"]', form);
    var submit = $('[data-submit]', form);
    var priceEl = $('[data-price]', form);
    var current = data.find(function (v) { return String(v.id) === String(idInput.value); }) || data[0];
    var chosen = current ? [current.option1, current.option2, current.option3] : [null, null, null];

    function money(cents) {
      try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR', maximumFractionDigits: 0 }); }
      catch (e) { return (cents / 100).toFixed(0); }
    }
    function sync() {
      var match = data.find(function (v) {
        return (chosen[0] == null || v.option1 === chosen[0]) &&
               (chosen[1] == null || v.option2 === chosen[1]) &&
               (chosen[2] == null || v.option3 === chosen[2]);
      });
      if (!match) { submit.disabled = true; submit.textContent = 'UNAVAILABLE'; return; }
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      submit.disabled = !match.available;
      submit.textContent = match.available ? 'ADD TO CART' : 'SOLD OUT';
      $$('[data-opt-current]', form).forEach(function (n) {
        var i = +n.getAttribute('data-opt-current') - 1;
        n.textContent = chosen[i] || '';
      });
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        history.replaceState({}, '', u);
      }
    }
    $$('[data-opt]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = +btn.getAttribute('data-opt') - 1;
        $$('[data-opt="' + (idx + 1) + '"]', form).forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        chosen[idx] = btn.getAttribute('data-value');
        sync();
      });
    });
    sync();
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(idInput.value, 1); });
  }

  /* ---------- blessing before checkout ---------- */
  function armBlessing() {
    var bless = $('#Blessing');
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-checkout]');
      if (!btn) return;
      if (!bless) return;
      e.preventDefault();
      closeCart();
      bless.hidden = false;
      var go = function () { window.location.href = '/checkout'; };
      bless.addEventListener('click', go, { once: true });
      setTimeout(go, 3600);
    });
  }

  /* ---------- chat ---------- */
  function armChat(root) {
    var log = $('.chat__log', root), inner = $('.chat__log-inner', root), form = $('form', root), input = $('input', form);
    var handle = root.getAttribute('data-handle');
    var persona = JSON.parse($('[data-persona]', root).textContent || '{}');
    var history = [];
    function pin() { if (log) log.scrollTop = log.scrollHeight; }
    function push(role, text) {
      var d = document.createElement('div');
      d.className = 'msg ' + (role === 'user' ? 'msg--me' : 'msg--hero');
      d.textContent = text;
      inner.appendChild(d); pin();
      history.push({ role: role === 'user' ? 'user' : 'assistant', content: text });
    }
    $$('.prompts button', root).forEach(function (b) {
      b.addEventListener('click', function () { input.value = b.textContent; input.focus(); });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var text = (input.value || '').trim(); if (!text) return;
      push('user', text); input.value = '';
      var typing = document.createElement('div');
      typing.className = 'msg msg--hero'; typing.textContent = '· · ·'; typing.style.animation = 'blink 1.2s infinite';
      inner.appendChild(typing); pin();
      fetch(window.PINAKA.chatProxy, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ handle: handle, hero: persona.hero, persona: persona.persona, lore: persona.lore, messages: history.slice(-8) })
      }).then(function (r) { return r.json(); })
        .then(function (j) {
          typing.remove();
          push('hero', (j && (j.reply || j.content)) || persona.fallbacks[history.length % persona.fallbacks.length]);
        })
        .catch(function () {
          typing.remove();
          push('hero', persona.fallbacks[history.length % persona.fallbacks.length]);
        });
    });
    pin();
  }

  /* ---------- loader: always removed, never blocks clicks ---------- */
  function killLoader() {
    var l = document.getElementById('Loader');
    if (!l || l.hidden) return;
    l.classList.add('is-out');
    setTimeout(function () { if (l.parentNode) l.parentNode.removeChild(l); }, 700);
  }
  setTimeout(killLoader, 2100);
  window.addEventListener('load', function () { setTimeout(killLoader, 600); });
  document.addEventListener('click', killLoader, true);

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(killLoader, 2100);
    armReveals(); armChakra(); armHero(); armBlessing();
    var g = $('[data-gallery]'); if (g) armGallery(g);
    var pf = $('[data-product-form]'); if (pf) armVariants(pf);
    var chat = $('[data-chat]'); if (chat) armChat(chat);

    document.addEventListener('click', function (e) {
      var qa = e.target.closest('[data-quick-add]');
      if (qa) { e.preventDefault(); openQuickAdd(qa.getAttribute('data-quick-add')); return; }
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
      var mc = e.target.closest('[data-modal-close]');
      if (mc) { mc.closest('.modal').hidden = true; return; }
      var q = e.target.closest('[data-qty]');
      if (q) { changeLine(+q.getAttribute('data-line'), +q.getAttribute('data-qty')); return; }
      var rm = e.target.closest('[data-remove]');
      if (rm) { changeLine(+rm.getAttribute('data-remove'), 0); return; }
      var qadd = e.target.closest('[data-quick-submit]');
      if (qadd) { e.preventDefault(); addToCart(qadd.getAttribute('data-variant'), 1); $('#SizeModal').hidden = true; }
    });

    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-quick-variant]');
      if (sel) { $('[data-quick-submit]').setAttribute('data-variant', sel.value); }
    });
  });
})();